const { localStorage } = window;

// Set domain to current domain and endpoint to popular.
const { origin } = window.location;
const apiUrl = `${origin}/wp-json/em/v1/popular`;

/**
 * Initiate favorite posts.
 */
const initPopularDocuments = () => {
	const documentLinks = document.querySelectorAll('.em-filterable-content__listings a');
	let popDocs = localStorage.getItem('popDocs');
	popDocs = popDocs ? JSON.parse(popDocs) : [];

	documentLinks.forEach((link) => {
		link.onclick = () => {
			const { id } = link.dataset;
			const index = popDocs.indexOf(id);

			if (index === -1) {
				(async () => {
					const response = await fetch(`${apiUrl}?id=${id}`);
					const data = await response.json();
					console.log(data);

					if (data) {
						popDocs.push(id);
					}

					localStorage.setItem('popularDocuments', JSON.stringify(popDocs));
				})();
			}
		};
	});
};

export default initPopularDocuments;
